module.exports = __webpack_public_path__ + "img/Card-Needs-HiRes.2f6ffc39.png";